import { AppBarSection } from "@progress/kendo-react-layout";
import { IUserProfile } from "../../../types/User/IUserProfile";
import {
  HamburgerMenu,
  IHamburgerMenuProps,
} from "./HamburgerMenu/HamburgerMenu";
import ProfileDropdown from "./ProfileDropdown/ProfileDropdown";
import QuickSearchWrapper from "./QuickSearch/QuickSearchWrapper";
import FocusedViewToggle from "./FocusedViewToggle";
import { PROFILE_NAV_CONTAINER_CLASS_NAME } from "../NavWrapper";
import Logout from "./Logout";
import { AdminArea } from "./AdminAreaButton";
import CoreIcon from "./CoreIcon";
import { useGetTenantQuery } from "../../../redux/api/BaseApi";
import { trimChar } from "../../../utils/utils";

export type ProfileNavProps = {
  data: IUserProfile;
  mimicUid: string;
  navStyle?: number
};

const ProfileNav = ({ props }: { props: ProfileNavProps }) => {
  const { data } = props;
  const { data: tenant } = useGetTenantQuery();
  const hamburgerMenuProps: IHamburgerMenuProps = {
    navItems: [...data.Nav_Items,
    ...(data.Features.Admin_Area ? [{
      Name: "Admin",
      Image_Url: "./images/Revelations_admin.png",
      Text: "Admin",
      Order: 0,
      Selected: false,
      Url: "/adminUX/DynamicUI/Default.aspx?PageName=HelpdeskSetup",
      Nav_Items: []
    }] : []),
    ...(data.Features.Numbers ? [{
      Name: "Numbers",
      Image_Url: "",
      Text: "Numbers",
      Order: 0,
      Selected: false,
      Url: "/Numbers/Default.aspx",
      Nav_Items: []
    }] : []),
    ],
    baseUrl: trimChar(tenant?.Tenant_Url, '/'),
  };
  return (
    <AppBarSection
      className={PROFILE_NAV_CONTAINER_CLASS_NAME}
      style={{
        maxWidth: "100%",
        gap: "1px",
      }}
    >
      {data.Is_Core_Site && <CoreIcon />}
      <ProfileDropdown {...props} />
      <QuickSearchWrapper accessible={data.Features.Quick_Search} />
      <FocusedViewToggle />
      <HamburgerMenu props={hamburgerMenuProps} />
      <AdminArea props={{ access: data.Features.Admin_Area }} />
      <Logout />
    </AppBarSection>
  );
};
export default ProfileNav;
